module.exports = __webpack_public_path__ + "static/media/EditReport.4e3788cb.svg";